<template>
  <div class="d-flex align-center" data-testid="materiality-count-card">
    <CountCard
      data-testid="materiality-count-card__total-card"
      :count="MaterialityCountCard || 0"
      page-name="users available"
      label-key="total_users_label"
      :fallback-label="$nova.labelsName('materiality_page', 'ru_entity_plural_label', 'Reporting Units')"
      :border-color="'#2C2C35'"
      :background-color="'#F7F7F7'"
      :height="'44px'"
      showWhenZero
      :loading="loading"
    />
  <v-spacer></v-spacer>
  <base-button large primary rounded :loading="hierarchyLoading || loading" :disabled="hierarchyLoading || loading" @click="$emit('materiality-file-upload')">Bulk Materiality Template</base-button>
   </div>
</template>
    <script>
import CountCard from '@/components/CommonCountCard.vue';

export default {
  name: 'MaterialityCountCard',
  components: {
    CountCard,
  },
  props: {
    MaterialityCountCard: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hierarchyLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>